// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-bar__wrapper[data-v-1cc64272]{display:flex}`, "",{"version":3,"sources":["webpack://./src/components/TopBar/TopBarMenu.vue"],"names":[],"mappings":"AACA,mCACC,YAAA","sourcesContent":["\n.top-bar__wrapper {\n\tdisplay: flex;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
